// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { EmptyCard } from 'components';

type Props = {
  ready: boolean,
  children?: React.Element<any>,
};

export class AppReady extends React.PureComponent<Props, void> {
  render() {
    const { ready, children } = this.props;

    return ready === true ? (
      children
    ) : (
      <EmptyCard modal message="Initializing" />
    );
  }
}

function mapStateToProps(state: Object): Object {
  return {
    ready: state.appConfig.sagaReady,
  };
}

export default connect(mapStateToProps, null)(AppReady);



// WEBPACK FOOTER //
// ./src/pages/__components__/AppReady.js